import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {AzureApiService} from "../../services/azure-api.service";
import {DtoUsedGiftCertificateFilter} from "./models/DtoUsedGiftCertificateFilter";
import {DtoUsedGiftCertificateOverview} from "./models/DtoUsedGiftCertificateOverview";

@Injectable()
export class UsedGiftcertificateService {
    constructor(private http: AzureApiService) {
    }

    getOverview(filter: DtoUsedGiftCertificateFilter): Observable<DtoUsedGiftCertificateOverview> {
        return this.http.post<DtoUsedGiftCertificateOverview>(`usedgiftcertificate/overview`, filter);
    };

    unbook(filter: DtoUsedGiftCertificateFilter, id: number): Observable<DtoUsedGiftCertificateOverview> {
        return this.http.post<DtoUsedGiftCertificateOverview>(`usedgiftcertificate/book/${id}`, filter);
    };
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/administration/used-giftcertificates/used-giftcertificate.service.ts